import { throttle } from 'lodash'

import { openBaeNotification } from '@/components/shared/notification-popup'
import { SECOND } from '@/constants/unit'
import { isNotificationMessage } from '@/model/notification'
import { AppDispatch, AppStore } from '@/redux'
import { refreshCreatorAuthToken } from '@/redux/creator-actions'
import { readNotificationCount, upsertNewNotification } from '@/redux/notification-actions'

import { getValidToken } from './auth'
import { getWebSocketUrl } from './env'

let socket: WebSocket

type RefreshNotificationCountFunc = (creatorId: number) => void;
const throttledRefreshCountFunctions: Record<number, RefreshNotificationCountFunc> = {}
const throttledReadNotificationCount = (creatorId: number, dispatch: AppDispatch) => {
  if (!throttledRefreshCountFunctions[creatorId]) {
    throttledRefreshCountFunctions[creatorId] = throttle((id: number) => {
      void dispatch(readNotificationCount({ creatorId: id }))
    }, 3 * SECOND)
  }
  return throttledRefreshCountFunctions[creatorId](creatorId)
}

export interface TokenRefreshMessage {
  payload: {
    creatorId: number
  }
  type: 'tokenRefresh'
}

export function isTokenRefreshMessage(data: TokenRefreshMessage): data is TokenRefreshMessage {
  return 'payload' in data && 'type' in data && data.type === 'tokenRefresh'
}

export const connectWebSocket = ({ getState, dispatch }: AppStore) => {
  let pingInterval: NodeJS.Timeout
  socket = new WebSocket(getWebSocketUrl())

  socket.onmessage = (event) => {
    const rawData = JSON.parse(event.data)
    if (isTokenRefreshMessage(rawData)) {
      dispatch(refreshCreatorAuthToken({
        creatorId: rawData.payload.creatorId,
        forceRefresh: false,
      }))
      return
    }
    if (isNotificationMessage(rawData)) {
      const { creatorId, data } = rawData
      void dispatch(upsertNewNotification({
        creatorId,
        notification: data,
      }))
      throttledReadNotificationCount(creatorId, dispatch)
      openBaeNotification({
        creatorId,
        notificationData: data,
        rootState: getState(),
        dispatch,
      })
      return
    }
  }

  socket.onopen = async () => {
    console.log('establishing websocket connection...')
    const { idToken } = await getValidToken()
    socket.send(JSON.stringify({ act: 'connect', token: idToken }))

    pingInterval = setInterval(() => {
      socket.send(JSON.stringify({ 'act': 'ping' }))
    }, 30 * SECOND)
  }

  socket.onclose = (message) => {
    console.log('websocket closed: ', message)
    clearInterval(pingInterval)
  }

  socket.onerror = (error) => {
    console.error('websocket error:', error)
  }
}

export const disconnectWebSocket = () => {
  if (socket) {
    socket.close()
  }
}